import avatar from '../assets/avatar.png'

export const Colors = {
    Base_color:'#126a38',
    Secondary_color :'#859318',
    bg_color:"#FFF4F7",
    white_color: '#fff',  
    Background:"#000",  
    Footer_text:'#909294',
    black_color:'#000',
    light_black: '#585455'
}  

export const CryptoKey = {
  secret_key: "ivpqxmrlbfhwcdtaehlbhdpje", // just a random strings
}
export const  GOOGLE_API_KEY ="AIzaSyAAoksYMoYE-bFNf3R3DvmZxH-qPsucQjc";
export const Web_url = {
    logo:'',
    squareImg:'',
    noImage:avatar,
    Base_url:'https://thenikamadhenu.uplogictech.com/api/',
    Domain_url:'https://thenikamadhenu.uplogictech.com/',
    App_Name: 'Theni Kamadhenu',
    web_url: 'https://thenikamadhenu.uplogictech.com/'
}


export const responsiveProps = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };



export const  ApiCall = async (url = '', data = {},method = 'Post')=> {
  var formBody=[];
  for (var property in data) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(data[property]);
      formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  
 const response= fetch( Web_url.Base_url+ url, {
      method: method,
      // Auth key here 
      headers: {
      'Authorization':  '',
      'Content-Type':'application/x-www-form-urlencoded'

    },
  
      body:formBody
  })
return (await response).json()
  
}
export const  FilterApi = async (url = '', data = {},method = 'Post')=> {
 const response= fetch( Web_url.Base_url+ url, {
      method: method,
      // Auth key here 
      headers: {
      'Authorization':  '',
      'Content-Type':'application/json'

    },
  
      body:JSON.stringify(data)
  })
return (await response).json()
  
}

